import React from 'react';
import '../Hero/Heading.css'

const Heading = () => {
  return (
    <div className='heroContainer'>
        <h3 className='heroSubtitle'>Established 2021.</h3>
        <h1 className='heroTitle'>
        Where Dreams Convert Into Homes</h1>
        <div className='homepageSearchBar'></div>
    </div>
  )
  ;
};

export default Heading;